// removed by extract-text-webpack-plugin
module.exports = {"box":"box_3BG4b","one":"one_2jel0","taskinput":"taskinput_926j9"};


//////////////////
// WEBPACK FOOTER
// ./containers/App/Tasks/newTasks/index.css
// module id = 1133
// module chunks = 0